import { MemberProps } from 'app/components/Core/convention'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

export const damageInfoTestId = 'damage_info-component-info'

const Info: React.FC<MemberProps<IDamageInfo>> = ({ member }) => {
  const {
    damage_circumstances,
    description,
    machine_model_number,
    perpetrator,
    machine_state,
    deductible,
    damage_payment_total
  } = member
  return (
    <div data-testid={damageInfoTestId}>
      <KInfo
        grid={{ xs: 1, md: 1, lg: 4, xl: 4, xxl: 6, gutter: 24 }}
        recordType={RecordType.damage_info}
        member={{
          machine_model_number,
          perpetrator,
          machine_state,
          deductible,
          damage_payment_total
        }}
      />
      <KInfo
        grid={{ xs: 1, md: 1, lg: 2, xl: 2, xxl: 2, gutter: 24 }}
        recordType={RecordType.damage_info}
        member={{
          damage_circumstances,
          description
        }}
      />
    </div>
  )
}

export default Info
